export default __webpack_public_path__ + "static/media/empty.b4b66586.svg";